define('charts/layers/ellipses',["require", "exports", "../../util/convert"], function (require, exports, convert_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Ellipses = void 0;
    var Ellipses = /** @class */ (function () {
        function Ellipses() {
        }
        Ellipses.prototype.init = function (chart) {
            // Add layers for ellipses
            this.svgGroup = chart.layers.space.append("g")
                .attr("class", "ellipses");
            this.canopy = this.svgGroup.append("ellipse")
                .attr("class", "canopy")
                .style("fill", "#9eff9e")
                .style("fill-opacity", 0.25);
            this.wingsuit = this.svgGroup.append("ellipse")
                .attr("class", "wingsuit")
                .style("fill", "#e1ccff")
                .style("fill-opacity", 0.25);
        };
        Ellipses.prototype.update = function (chart) {
            var cx = chart.xAxis.scale(convert_1.default.speed.localValue(11.6));
            var cy = chart.yAxis[0].scale(convert_1.default.speed.localValue(-6.25));
            this.canopy
                .attr("cx", cx)
                .attr("cy", cy)
                .attr("rx", cx - chart.xAxis.scale(convert_1.default.speed.localValue(0.9)))
                .attr("ry", cy - chart.yAxis[0].scale(convert_1.default.speed.localValue(-0.9)))
                .attr("transform", "rotate(9 " + cx + " " + cy + ")");
            cx = chart.xAxis.scale(convert_1.default.speed.localValue(40.2));
            cy = chart.yAxis[0].scale(convert_1.default.speed.localValue(-22.35));
            this.wingsuit
                .attr("cx", cx)
                .attr("cy", cy)
                .attr("rx", cx - chart.xAxis.scale(convert_1.default.speed.localValue(18.8)))
                .attr("ry", cy - chart.yAxis[0].scale(convert_1.default.speed.localValue(-9.8)))
                .attr("transform", "rotate(35 " + cx + " " + cy + ")");
        };
        Ellipses.prototype.remove = function () {
            this.svgGroup.remove();
        };
        return Ellipses;
    }());
    exports.Ellipses = Ellipses;
});
//# sourceMappingURL=/assets/javascripts/charts/layers/ellipses.js.map;
